const ALLOWED_BATCH_ACTIONS = new Set(["duplicate", "delete"]);

export async function loadSentRows(api, moduleCode) {
    const code = String(moduleCode || "").trim().toUpperCase();
    const response = await api.get(`/telematico/invii/sent?module_code=${encodeURIComponent(code)}`);
    return Array.isArray(response.data) ? response.data : [];
}

export async function runSentBatchAction(api, action, praticaIds) {
    if (!ALLOWED_BATCH_ACTIONS.has(action)) {
        throw new Error("Azione non supportata");
    }
    const ids = [...new Set((praticaIds || []).filter(Boolean))];
    if (!ids.length) return { action, processed: 0, results: [] };
    const response = await api.post("/pratiche/sent/batch-actions", {
        action,
        pratica_ids: ids,
    });
    return response.data;
}

export function sentOutcomeClass(status) {
    if (status === "ACQUISITA" || status === "ACCETTATA") return "border-emerald-300 bg-emerald-50 text-emerald-800";
    if (status === "SCARTATA") return "border-red-300 bg-red-50 text-red-800";
    return "border-amber-300 bg-amber-50 text-amber-800";
}
